import React, { useEffect, useState } from 'react';
import AddDataModal from "./AddDataModal";
import EditDataModal from "./EditDataModal";
import Paginator from "../../components/common/Paginator/Paginator";

const Users = React.memo(({ users, getUsersTh, ...props }) => {
    let [isEditUser, setIsEditUser] = useState(false);
    let [isCreateUser, setIsCreateUser] = useState(false);
    let [userId, setUserId] = useState();
    const [show, setShow] = useState(false);

    useEffect(() => {
        if (isCreateUser) setShow(isCreateUser);
    }, [isCreateUser]);

    useEffect(() => {
        if (isEditUser) setShow(isEditUser);
    }, [isEditUser]);

    const EditUser = (event) => {
        setUserId(event.target.id);
        setIsEditUser(true);
    };

    const AddUser = () => {
        setIsCreateUser(true);
    };

    const handlePageChange = (page, size) => {
        if (typeof getUsersTh === 'function') {
            getUsersTh(page, size);
        }
    };

    const truncate = (value, max = 30) => {
        if (value === null || value === undefined) return '';
        const str = String(value);
        return str.length > max ? str.slice(0, max) + '…' : str;
    };

    const formatDate = (value) => {
        if (!value) return '—';
        const d = new Date(value);
        return isNaN(d.getTime()) ? value : d.toLocaleString('az-AZ');
    };

    let usersList = users?.map(user => (
        <tr key={user.id}>
            <td>{user.id}</td>
            <td title={user.name} style={{ maxWidth: "220px", overflow: "hidden", textOverflow: "ellipsis" }}>
                {truncate(user.name)}
            </td>
            <td title={user.email} style={{ maxWidth: "260px", overflow: "hidden", textOverflow: "ellipsis" }}>
                {truncate(user.email, 40)}
            </td>
            <td>
                {user.role === 'admin' ?
                    <span className="badge badge-pill badge-primary">Admin</span> :
                    <span className="badge badge-pill badge-secondary">User</span>
                }
            </td>
            <td>{formatDate(user.created_at)}</td>
            <td>
                <span className="badge bg-warning"
                      id={user.id}
                      style={{ cursor: "pointer" }}
                      onClick={EditUser}>Redaktə</span>
            </td>
        </tr>
    ));

    return (
        <div>
            {isCreateUser &&
            <AddDataModal
                show={isCreateUser}
                addUserTh={props.addUserTh}
                setIsCreateUser={setIsCreateUser}
                {...props}
            />
            }
            {isEditUser &&
            <EditDataModal
                show={isEditUser}
                setIsEditUser={setIsEditUser}
                userId={userId}
                users={users}
                updateUserTh={props.updateUserTh}
                changeUserPasswordTh={props.changeUserPasswordTh}
                deleteUserTh={props.deleteUserTh}
                {...props}
            />
            }
            <div className="card ml-1 mr-1">
                <div className="card-header">
                    <h3 className="card-title">İstifadəçilər</h3>
                    <div className="card-tools">
                        <Paginator
                            totalElements={props.totalElements}
                            totalPages={props.totalPages}
                            size={props.size}
                            getNewPorsion={handlePageChange}
                        />
                    </div>
                </div>
                <div className="card-body p-0" style={{ overflowX: 'auto' }}>
                    <table className="table" style={{ whiteSpace: 'nowrap' }}>
                        <thead>
                        <tr>
                            <th style={{ width: "10px" }}>Id</th>
                            <th style={{ maxWidth: "220px" }}>Ad</th>
                            <th style={{ maxWidth: "260px" }}>Email</th>
                            <th>Rol</th>
                            <th>Yaranma tarixi</th>
                            <th style={{ width: "40px" }}>
                                <span className="badge bg-info"
                                      style={{ cursor: "pointer" }}
                                      onClick={AddUser}>Əlavə Et</span>
                            </th>
                        </tr>
                        </thead>
                        <tbody>
                        {usersList && usersList.length > 0 ? usersList :
                            <tr><td colSpan="6" className="text-center">Məlumat yoxdur</td></tr>}
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    );
});

export default Users;
